(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1639],{

/***/ 77408:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tour/[travelSlug]",
      function () {
        return __webpack_require__(92005);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _travelSlug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/pages/TravelPage/index.tsx + 16 modules
var TravelPage = __webpack_require__(26465);
// EXTERNAL MODULE: ./src/components/elements/seo/SeoHeader/index.ts + 1 modules
var SeoHeader = __webpack_require__(32192);
// EXTERNAL MODULE: ./src/app/context.ts
var context = __webpack_require__(27802);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/integrations/tracking/custom-sea-tracking/SeaTracker.ts + 1 modules
var SeaTracker = __webpack_require__(19838);
;// CONCATENATED MODULE: ./src/integrations/tracking/custom-sea-tracking/hooks/usePageLoadTracking.ts



var usePageLoadTracking = function(objectName, pathPattern, eventName) {
    var router = (0,next_router.useRouter)();
    var hasTrackedRef = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Make sure the router is ready
        if (!router.isReady) return;
        // Initialize tracker with router to capture full URL including query parameters
        SeaTracker/* default.init */.Z.init(router);
        // Track on initial page load if not tracked yet
        if (router.pathname.includes(pathPattern) && !hasTrackedRef.current) {
            if (eventName === "View_Tour") {
                SeaTracker/* default.trackViewTour */.Z.trackViewTour(objectName);
            } else {
                // Add other eventNames as needed
                console.log("Tracking event ".concat(eventName, " not implemented yet"));
            }
            hasTrackedRef.current = true;
        }
        // For navigation between different entities
        var handleRouteChange = function(url) {
            if (url.includes(pathPattern) && url !== router.asPath) {
                // Reset the flag when navigating to a different entity
                hasTrackedRef.current = false;
            }
        };
        router.events.on("routeChangeStart", handleRouteChange);
        return function() {
            router.events.off("routeChangeStart", handleRouteChange);
        };
    }, [
        router.isReady,
        router.events,
        router.asPath,
        router.pathname,
        objectName,
        pathPattern,
        eventName,
        router
    ]);
};

;// CONCATENATED MODULE: ./src/pages/tour/[travelSlug].tsx





var TravelSinglePage = function(param) {
    var travel = param.travel, cmsConfig = param.cmsConfig;
    usePageLoadTracking(travel.seoSettings.urlSlug, "/tour/", "View_Tour");
    if (!travel.seoSettings.ogImage.publicId) {
        travel.seoSettings.ogImage = travel.mainImage;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoHeader/* default */.Z, {
                seoSettings: travel.seoSettings
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* TravelIdContext.Provider */.Hu.Provider, {
                value: travel.id,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelPage/* default */.Z, {
                    travel: travel,
                    cmsConfig: cmsConfig
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _travelSlug_ = (TravelSinglePage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [789,7478,2367,1664,2247,8037,5583,562,651,6212,9836,2027,6466,2298,6164,6465,9774,2888,179], function() { return __webpack_exec__(77408); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);